
import React, { useState , useEffect } from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { Row, Col, FormGroup } from "reactstrap";
import { API_URL } from "../../constent";
import axios from "axios";
import style from '../../../src/assets/scss/theme.css'

import {
    Block,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
  } from "../../components/Component";
const ShowComparison = ({ match }) => {

    const [tableData, setTableData] = useState([]);
    const [desp, setDesp] = useState('');
    const [loading, setLoading] = useState(false);
    const comp_id = match.params.id;
    
    useEffect(() => {
        var userData = JSON.parse(localStorage.getItem('userData'));
        var getuserid = userData?.[0]?.id;
        
        axios.get(`${API_URL}showcomparison/${comp_id}`).then((result)=>
        {
            console.log(result.data);
            setTableData(result.data.comp_data);
            setDesp(result.data.description);
            setLoading(false);
        })
    } , []) 
    


    if (loading) {
        return(
           <>
             <p>Loading....</p>
           </>
        ) 
    } 

    return(
        <React.Fragment>
        <Head title="Show Comparison" />
            <Content page="component">

            <Block size="lg">
              
                <div style={{background:'#fff', padding:"14px"}}>

                <Row className="g-gs" style={{background:'#e8ecf1',borderRadius:'0px 0px 10px 10px',marginBottom:'20px'}}>
                    <Col lg="4">
                        <img src="https://i0.wp.com/www.bornorganic.com.au/wp-content/uploads/dummy-logoArtboard-1born-logo.png?ssl=1" />
                    </Col>
                    <Col lg="8">
                        <Col tag="h4">P.V.Krishnan</Col>
                        <Col tag="h5">Health Insurance Advisor</Col>
                        <Col tag="h6">+919935420427</Col>
                        <Col tag="h6">pvk27@krishnansolution.com</Col>
                    </Col>
                </Row>
                <Row className="g-gs">
                    
                    <Col lg="12">
                    <Col tag="h4" className="policy_css">Policy Details</Col>
                   
                    <table className="table table-bordered table-striped">
                        <tbody>
                        {tableData.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                            {row.map((cell, colIndex) => (
                                <td key={colIndex} style={{ padding: "8px" }}>
                                {cell}
                                </td>
                            ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </Col>
                    <Col lg="12">
                      <Col tag="h5">Important Descriptions</Col>
                      <Col tag="h6">{desp}</Col>
                    </Col>
                </Row>

                </div>
                

            </Block>
            </Content>
        </React.Fragment>
    )
}

export default ShowComparison;